import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import UserAvatar from "../../../components/mui/material/UserAvatar";
import MentionSpan from "../../../components/MentionSpan";
import { postNotification } from "../../../actions";
var tKey = "wrappers.NotificationToastsDecorator.impl.PostReplyCreatedNotificationToast";
function PostReplyCreatedNotificationToast(props) {
  var notificationId = props.notificationId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var navigate = useNavigate();
  var dispatch = useDispatch();
  var notification = useSelector(function (state) {
    return state.entities.notifications.byId[notificationId];
  });
  var postId = notification.event.objects[0].objectId;
  var post = useSelector(function (state) {
    return state.entities.posts.byId[postId];
  });
  function handleClick() {
    notification.viewedAt = moment().toISOString();
    dispatch(postNotification(notification));
    toast.dismiss(notificationId);
    navigate("/posts/".concat(post.id));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center",
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0"
  }, /*#__PURE__*/React.createElement(UserAvatar, {
    user: post.user
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-grow-1 ms-2"
  }, /*#__PURE__*/React.createElement("div", null, t("".concat(tKey, ".header"), {
    userDisplayableName: post.user.displayableName
  }), "\xA0\xB7\xA0", moment(notification.createdAt).fromNow(true)), /*#__PURE__*/React.createElement("div", null, post.text && /*#__PURE__*/React.createElement(MentionSpan, {
    linksDisabled: true,
    postId: postId
  }, "\"".concat(post.text, "\"")))));
}
export default PostReplyCreatedNotificationToast;
PostReplyCreatedNotificationToast.propTypes = {
  notificationId: PropTypes.number.isRequired
};